import { render } from "./DebtorsPage.vue?vue&type=template&id=17b96bdd&scoped=true"
import script from "./DebtorsPage.vue?vue&type=script&lang=js"
export * from "./DebtorsPage.vue?vue&type=script&lang=js"

import "./DebtorsPage.vue?vue&type=style&index=0&id=17b96bdd&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17b96bdd"]])

export default __exports__